<template>
<v-dialog max-width="1000px" v-model="modalState">
    <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" v-bind="attrs" v-on="on">
            <v-icon small>mdi-plus</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp" class="ml-2">{{ $page.props.lang.newWorkout || "New Workout" }}</span>
        </v-btn>
    </template>
    <template v-slot:default="newWorkout">
        <v-card>
            <v-toolbar elevation="0">
                <v-toolbar-title>New Workout</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="newWorkout.value = false"> 
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-container class="mt-4">
                <v-row>
                    <v-col cols="12">
                        <label class="custom-label">{{ $page.props.lang.name || 'Name' }}</label>
                        <v-text-field v-model="workout.name" 
                            :error-messages="responseErrors.name" 
                            :hide-details="!responseErrors.name"
                            @focus="responseErrors.name=''"
                            outlined dense solo flat></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <label class="custom-label">{{ $page.props.lang.description || 'Description' }}</label>
                        <v-textarea v-model="workout.description" 
                            :error-messages="responseErrors.description" 
                            :hide-details="!responseErrors.description"
                            @focus="responseErrors.description=''" 
                            outlined dense solo flat></v-textarea>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <label class="custom-label">{{ $page.props.lang.level || 'Level' }}</label>
                        <v-rating v-model="workout.level" background-color="primary lighten-3" color="primary"></v-rating>
                    </v-col>
                </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="regular" @click="newWorkout.value = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                <v-btn @click="createWorkout" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
            </v-card-actions>
        </v-card>
    </template>
</v-dialog>
    
</template>
<script>

import ExerciseBuilder from './ExerciseBuilder'

export default {
    components: {
        ExerciseBuilder
    },
    data(){
        return {
            modalState: false,
            responseErrors: {},
            workout:{
                name: '',
                description: '',
                level: 3,
            }
        }
    },

    methods: {
        createWorkout(){
            // axios.post('/backoffice/workouts/store', this.workout)
            // .then((r) => {
            //     console.log(r);
            // })
            this.$inertia.post('/backoffice/workouts/store', this.workout);
        }
       
    }
}
</script>
